function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconattention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24 42.7998C34.383 42.7998 42.7998 34.383 42.7998 24C42.7998 13.617 34.383 5.2002 24 5.2002C13.617 5.2002 5.2002 13.617 5.2002 24C5.2002 34.383 13.617 42.7998 24 42.7998Z",
    stroke: "#0B40A9",
    style: {
      stroke: "#0B40A9",
      stroke: "color(display-p3 0.0431 0.2510 0.6627)",
      strokeOpacity: 1
    },
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 14.8572L24 26",
    stroke: "#0B40A9",
    style: {
      stroke: "#0B40A9",
      stroke: "color(display-p3 0.0431 0.2510 0.6627)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 22 33.6641)",
    fill: "#0B40A9",
    style: {
      fill: "#0B40A9",
      fill: "color(display-p3 0.0431 0.2510 0.6627)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconattention);
export default __webpack_public_path__ + "static/media/icon attention.5ef41cf1ff4b3e1853b1a67e7605ba1d.svg";
export { ForwardRef as ReactComponent };